import { notificationSettings } from "../../constants/actionTypes";

const requestNotificationTypes = () => ({
  type: notificationSettings.REQUEST_NOTIFICATION_TYPES,
});

const successNotificationTypes = (data) => ({
  type: notificationSettings.SUCCESS_NOTIFICATION_TYPES,
  payload: data,
});

const errorNotificationTypes = (data) => ({
  type: notificationSettings.ERROR_NOTIFICATION_TYPES,
  payload: data,
});

const fetchNotificationTypesList = (data) => ({
  type: notificationSettings.FETCH_NOTIFICATION_TYPES_LIST,
  payload: data,
});

const successNotificationTypesList = (data) => ({
  type: notificationSettings.SUCCESS_NOTIFICATION_TYPES_LIST,
  payload: data,
});

const errorNotificationTypesList = (data) => ({
  type: notificationSettings.ERROR_NOTIFICATION_TYPES_LIST,
  payload: data,
});

const fetchReportNotificationTypeList = (data) => ({
  type: notificationSettings.FETCH_REPORT_NOTIFICATION_TYPE_LIST,
  payload: data,
});

const successReportNotificationTypeList = (data) => ({
  type: notificationSettings.SUCCESS_REPORT_NOTIFICATION_TYPE_LIST,
  payload: data,
});

const errorReportNotificationTypeList = (data) => ({
  type: notificationSettings.ERROR_REPORT_NOTIFICATION_TYPE_LIST,
  payload: data,
});

const updateReportNotificationSettings = (data) => ({
  type: notificationSettings.UPDATE_REPORT_NOTIFICATION_SETTINGS,
  payload: data,
});

const successUpdateReportNotification = (data) => ({
  type: notificationSettings.SUCCESS_UPDATE_REPORT_NOTIFICATION,
  payload: data,
});

const updateNotificationSettings = (data) => ({
  type: notificationSettings.UPDATE_NOTIFICATION_SETTINGS,
  payload: data,
});

const successNotificationSettings = (data) => ({
  type: notificationSettings.SUCCESS_NOTIFICATION_SETTINGS,
  payload: data,
});

const errorNotificationSettings = (data) => ({
  type: notificationSettings.ERROR_NOTIFICATION_SETTINGS,
  payload: data,
});

const requestPhoneNumber = (data) => ({
  type: notificationSettings.REQUEST_PHONE_NUMBER,
  payload: data,
});

const successPhoneNumber = (data) => ({
  type: notificationSettings.SUCCESS_PHONE_NUMBER,
  payload: data,
});

const errorPhoneNumber = (data) => ({
  type: notificationSettings.ERROR_PHONE_NUMBER,
  payload: data,
});

export {
  requestNotificationTypes,
  successNotificationTypes,
  errorNotificationTypes,
  fetchNotificationTypesList,
  successNotificationTypesList,
  errorNotificationTypesList,
  fetchReportNotificationTypeList,
  successReportNotificationTypeList,
  errorReportNotificationTypeList,
  updateReportNotificationSettings,
  successUpdateReportNotification,
  updateNotificationSettings,
  successNotificationSettings,
  errorNotificationSettings,
  requestPhoneNumber,
  successPhoneNumber,
  errorPhoneNumber,
};
